const service = function () {
	this.notifications = []
	this.observers = []
  this.seeMoreFunction = null
  this.openSetting = null
  this.total = 0


	this.onNotificationChange = (callback) => {
		this.observers.push(callback)
	}

	this.setNotifications = (_notifications) => {
		this.notifications = _notifications.sort((a, b) => b.longDate - a.longDate)
		this.observers.forEach((observer) => {
			observer(this.notifications)
		})
	}

  this.addToNotifications = (_notifications) => {
		this.notifications = this.notifications.concat(_notifications).sort((a, b) => b.longDate - a.longDate)
		this.observers.forEach((observer) => {
			observer(this.notifications)
		})
	}

  this.setTotal = (total = 0) => {
    this.total = total
  }

  this.setSeeMoreFunction = (funct) => {
    this.seeMoreFunction = funct
  }

  this.setOpenSetting = (funct) => {
    this.openSetting = funct
  }
}

export default service;



// WEBPACK FOOTER //
// ./src/modules/topbar/services/base-notification-service.js